import React, { useState } from 'react';

const SortToggle = ({ onChange, sortOrder }) => {
    const [active, setActive] = useState(sortOrder); // 'popular' or 'newest'

    const handleToggle = (value) => {
        setActive(value);
        if (onChange) onChange(value); // trigger external callback
    };

    return (
        <div className={`relative inline-flex bg-gray-100 p-1 rounded-lg  ${sortOrder == "desc" ? 'bg-blurred-gradient' : 'bg-blurred-gradientright'}`}>
            {/* Sliding background indicator */}
            <span
                className={`absolute top-1 left-1 w-[calc(50%-0.25rem)] h-[calc(100%-0.5rem)] rounded-lg bg-white shadow transition-all duration-300 ${active === 'asc' ? 'translate-x-0' : 'translate-x-full'
                    }`}
            />

            {/* Popular */}
            <button
                onClick={() => handleToggle('asc')}
                className={`relative z-10 flex items-center gap-1 px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 ${active === 'asc' ? 'text-gray-900 bg-white' : 'text-gray-600 hover:text-gray-800'
                    }`}
            >
                {/* TrendingUp Icon */}
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-4 h-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                >
                    <path d="M3 17l6-6 4 4 8-8" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                Oldest
            </button>

            {/* Newest */}
            <button
                onClick={() => handleToggle('desc')}
                className={`relative z-10 flex items-center gap-1 px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 ${active === 'desc' ? 'text-gray-900 bg-white' : 'text-gray-600 hover:text-gray-800'
                    }`}
            >
                {/* Calendar Icon */}
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-4 h-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M8 7V3m8 4V3m-9 8h10m2-7H5a2 2 0 00-2 2v12a2 2 0 002 2h14a2 2 0 002-2V6a2 2 0 00-2-2z"
                    />
                </svg>
                Newest
            </button>
        </div>
    );
};

export default SortToggle;